var exports = {
  "Y": "xcc377c0b--493118--modal-content",
};

module.exports = exports;
